import {
    Prescripteur,
    useFormaliteService,
    useSociete,
    useTiersService,
} from '@europrocurement/l2d-domain';
import {
    INIT_ITEMS_CTX,
    useDossierValidatorCtxDispatch,
    useDossierValidatorsCtx,
} from '../providers/DossierValidatorsProvider';
import {
    ADD_TIERS_CTX,
    apiToStateTransformer,
    START_FETCH_TIERS_CTX,
    STOP_FETCH_TIERS_CTX,
    useTiersCtx,
    useTiersCtxDispatch,
} from '../providers/TiersProvider';

const useLazyDataLoader = () => {
    const { isDataLoaded: validatorsDataLoaded } = useDossierValidatorsCtx();
    const validatorsDispatch = useDossierValidatorCtxDispatch();
    const { validatorsApi } = useFormaliteService();
    const tiersDispatch = useTiersCtxDispatch();
    const { isFetch } = useTiersCtx();
    const { prescribersApi } = useTiersService();
    const xIdSociete = useSociete();

    const loadValidators = async (): Promise<void> => {
        if (validatorsDataLoaded() || !validatorsDispatch) {
            return Promise.resolve();
        }

        const response = await validatorsApi.apiDossiersValideursGetCollection({
            itemsPerPage: 999,
        });
        validatorsDispatch({
            type: INIT_ITEMS_CTX,
            payload: response.data['hydra:member'],
        });

        return Promise.resolve();
    };

    const loadTiers = async (tiersId: number, force: boolean = false): Promise<void> => {
        if (!tiersDispatch || (isFetch(tiersId) && !force)) {
            return Promise.resolve();
        }

        tiersDispatch({
            type: START_FETCH_TIERS_CTX,
            payload: tiersId,
        });

        const response = await prescribersApi.getTiersTiersItem({
            id: tiersId as unknown as string,
            xIdSociete,
        });

        tiersDispatch({
            type: ADD_TIERS_CTX,
            payload: apiToStateTransformer(response.data as Prescripteur, xIdSociete),
        });
        tiersDispatch({
            type: STOP_FETCH_TIERS_CTX,
            payload: tiersId,
        });

        return Promise.resolve();
    };

    const refreshTiers = async (tiersId: number): Promise<void> => {
        if (!tiersDispatch) {
            return Promise.resolve();
        }

        return loadTiers(tiersId, true);
    };

    return { loadValidators, loadTiers, refreshTiers };
};

export default useLazyDataLoader;
